import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Download, Phone, Mail, Droplets } from 'lucide-react';
import { carWashData } from '../mock';

const PriceList = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="fixed top-0 w-full bg-white/95 backdrop-blur-sm border-b border-slate-200 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <a href="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_shine-station-3/artifacts/t37ax4ki_Logo_Trushine.png" 
              alt="Trushine Logo" 
              className="h-24 w-auto"
            />
          </a>
          <nav className="hidden md:flex gap-8">
            <a href="/#services" className="text-slate-700 hover:text-slate-900 font-medium transition-colors">Servicios</a>
            <a href="/#about" className="text-slate-700 hover:text-slate-900 font-medium transition-colors">Nosotros</a>
            <a href="/lista-de-precios" className="text-slate-700 hover:text-slate-900 font-medium transition-colors border-b-2 border-slate-900">Lista de Precios</a>
            <a href="/#contact" className="text-slate-700 hover:text-slate-900 font-medium transition-colors">Contacto</a>
          </nav>
          <a href="https://wa.me/573044175754" target="_blank" rel="noopener noreferrer">
            <Button className="bg-slate-900 hover:bg-slate-800 text-white">Reservar Ahora</Button>
          </a>
        </div>
      </header>

      {/* Main Content */}
      <div className="pt-24 pb-20">
        <div className="container mx-auto px-4">
          {/* Page Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Lista de Precios 2026
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Precios competitivos para servicios de detallado y lavado premium
            </p>
          </div>

          {/* Price List Image */}
          <Card className="max-w-5xl mx-auto shadow-2xl border-2 border-slate-200 overflow-hidden">
            <CardContent className="p-0">
              <img 
                src="https://customer-assets.emergentagent.com/job_shine-station-3/artifacts/2r3pi0ii_Lista_Precios_2026.png" 
                alt="Lista de Precios Trushine 2026"
                className="w-full h-auto"
              />
            </CardContent>
          </Card>

          {/* Download Button */}
          <div className="text-center mt-8">
            <a 
              href="https://customer-assets.emergentagent.com/job_shine-station-3/artifacts/2r3pi0ii_Lista_Precios_2026.png" 
              download="Lista_Precios_Trushine_2026.png"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button size="lg" className="bg-amber-600 hover:bg-amber-700 text-white">
                <Download className="w-5 h-5 mr-2" />
                Descargar Lista de Precios
              </Button>
            </a>
          </div>

          {/* Contact CTA */}
          <div className="mt-16">
            <Card className="bg-slate-900 text-white border-0">
              <CardContent className="p-8 md:p-12">
                <div className="text-center">
                  <h2 className="text-3xl md:text-4xl font-bold mb-4">
                    ¿Tienes Preguntas sobre Nuestros Servicios?
                  </h2>
                  <p className="text-xl text-slate-300 mb-8">
                    Contáctanos para más información o para programar tu cita
                  </p>
                  <div className="flex flex-wrap justify-center gap-6">
                    <a href="https://wa.me/573044175754" target="_blank" rel="noopener noreferrer">
                      <Button size="lg" className="bg-amber-600 hover:bg-amber-700 text-white">
                        <Phone className="w-5 h-5 mr-2" />
                        {carWashData.contact.phone}
                      </Button>
                    </a>
                    <a href={`mailto:${carWashData.contact.email}`}>
                      <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-slate-900">
                        <Mail className="w-5 h-5 mr-2" />
                        Enviar Email
                      </Button>
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-950 text-slate-400 py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_shine-station-3/artifacts/t37ax4ki_Logo_Trushine.png" 
                  alt="Trushine Logo" 
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-slate-400">
                Servicios premium de detallado y lavado de autos en los que puede confiar.
              </p>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">Enlaces Rápidos</h3>
              <ul className="space-y-2">
                <li><a href="/#services" className="hover:text-amber-600 transition-colors">Servicios</a></li>
                <li><a href="/#about" className="hover:text-amber-600 transition-colors">Nosotros</a></li>
                <li><a href="/lista-de-precios" className="hover:text-amber-600 transition-colors">Lista de Precios</a></li>
                <li><a href="/#contact" className="hover:text-amber-600 transition-colors">Contacto</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-4">Información de Contacto</h3>
              <ul className="space-y-2">
                <li>{carWashData.contact.phone}</li>
                <li>{carWashData.contact.email}</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-800 pt-8 text-center">
            <p>&copy; 2025 Trushine Car Detailing. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PriceList;
